declare namespace $ {

	type $mol_image__uri_bog_pazzle_saves_item_1 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves_item['thumb'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_image__title_bog_pazzle_saves_item_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_image['title'] >
	>
	type $mol_text__text_bog_pazzle_saves_item_3 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves_item['label'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_bog_pazzle_saves_item_4 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves_item['stat'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_bog_pazzle_saves_item_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_minor__hint_bog_pazzle_saves_item_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_pazzle_saves_item_7 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves_item['open_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_pazzle_saves_item_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_pazzle_saves_item_9 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves_item['drop_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_pazzle_saves_item_10 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves_item['drop_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__attr_bog_pazzle_saves_item_11 = $mol_type_enforce<
		({ 
			'bog_pazzle_confirm': ReturnType< $bog_pazzle_saves_item['confirm'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		,
		ReturnType< $mol_button_minor['attr'] >
	>
	type $mol_button_minor__sub_bog_pazzle_saves_item_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_pazzle_saves_item extends $mol_view {
		open_click( next?: any ): any
		thumb( ): string
		Thumb( ): $mol_image
		label( ): string
		Label( ): $mol_text
		stat( ): string
		Stat( ): $mol_text
		Info( ): $mol_list
		Open( ): $mol_button_minor
		drop_hint( ): string
		drop_click( next?: any ): any
		confirm( next?: boolean ): boolean
		Drop_icon( ): $mol_icon_delete
		Drop( ): $mol_button_minor
		id( ): string
		open( next?: any ): any
		drop( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map